import styled from 'styled-components';

export const TilesContainer = styled.div`
  margin-top: ${(props) => props.top || '32px'};
  margin-bottom: ${(props) => props.bottom || '32px'};
  background-color: ${(props) => props.bgColor || '#f6f6f6'};
  border-radius: ${(props) => props.radius || '8px'};
  padding: ${(props) => props.padding || '24px'};
  position: relative;
  box-sizing: border-box;
  text-align: left;

  width: ${(props) => props.width || '100%'};
  display: ${(props) => props.display || 'block'};
  justify-content: space-between;
  align-items: center;

  @media (max-width: 428px) {
    padding: ${(props) => props.padding || props.mPadding || '24px 16px'};
  }

  .detailsContainer {
    display: flex;
    width: ${(props) => props.containerWidth || '60%'};
    padding-right: 40px;
    @media (max-width: 450px) {
      width: 100%;
      padding-right: 0%;
    }
  }

  .rowContainer {
    display: flex;
    justify-content: space-between;
  }

  .miscContainer {
    width: ${(props) => (props?.hasDevice ? '40%' : '60%')};
    @media (max-width: 450px) {
      width: 100%;
    }
  }
  .imageContent {
    padding-right: 10px;
  }
`;

export const DeviceContainer = styled.div`
  display: flex;
  @media (max-width: 450px) {
    display: block;
  }
`;

export const PlanLinkContainer = styled.div`
  align-self: flex-start;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: ${(props) => props.align || 'initial'};
`;

export const DeviceAddOnContainer = styled.div`
  /* width: ${(props) => (props?.hasDevice ? '40%' : '60%')}; */
  width: 100%;
  /* @media (max-width: 450px) {
    width: 100%;
  } */
`;

export const TextLinkContainer = styled.div`
  align-self: center;
  margin-top: ${(props) => props.top};
`;

export const Container = styled.div`
  max-width: ${(props) => props.maxWidth};
  width: ${(props) => props.width};
  @media (max-width: 450px) {
    text-align: ${(props) => props.align};
  }
  [class^='TooltipWrapper-sc'] {
    top: 2px;
  }
`;

export const RightTextContainer = styled(Container)`
  text-align: end;
`;
// export const EditLink = styled(TextLink)`
//   color: #6f7171;
// `;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;
